import { render, staticRenderFns } from "./SatelliteRouters.vue?vue&type=template&id=a65a8cbe&scoped=true"
import script from "./SatelliteRouters.vue?vue&type=script&lang=js"
export * from "./SatelliteRouters.vue?vue&type=script&lang=js"
import style0 from "./SatelliteRouters.vue?vue&type=style&index=0&id=a65a8cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65a8cbe",
  null
  
)

export default component.exports